<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="diligences"
      item-key="id"
      :server-items-length="studentCount"
      :options.sync="tableOptions"
      :footer-props="tableFooterOptions"
      :loading="loading"
      loading-text="Đang Tải"
    >
      <!-- Học sinh -->
      <template v-slot:[`item.student`]="{ item }">
        <CardStudentName :student="item.student" link />
      </template>
      <!-- Ngày sinh -->
      <template v-slot:[`item.dob`]="{ item }">
        {{ item.student.dob | ddmmyyyy }}
      </template>
      <template v-slot:[`item.date`]="{ item }">
        {{ item.date | ddmmyyyy }}
      </template>
      <template v-slot:[`item.status`]="{ item }">
        <div v-if="item.status === 'present' || item.status === 'absent'">
          <div class="pt-2" style="height: 36px"></div>
        </div>
        <div v-else>
          <v-chip small label :color="item.status | getDiligenceStatusColor">
            <span>
              {{ item.status | getDiligenceStatus }}
            </span>
          </v-chip>
        </div>
      </template>
      <template v-slot:[`item.present`]="{ item }">
        <div v-if="item.present">
          <div class="pt-2" style="height: 36px">
            <v-chip small label :color="'#00C853'" dark>
              <span> Có mặt</span>
            </v-chip>
          </div>
        </div>
        <div v-else-if="item.status === 'absent'">
          <div class="pt-2" style="height: 36px">
            <v-chip small label :color="'#FF9800'" dark>
              <span> Vắng mặt</span>
            </v-chip>
          </div>
        </div>
        <div v-else>
          <div class="pt-2" style="height: 36px">
            <v-chip small label :color="'#FBC02D'">
              <span>Vắng mặt</span>
            </v-chip>
          </div>
        </div>
      </template>
      <template v-slot:[`item.class`]="{ item }">
        {{ item | _get('class.title') }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import utils from '@/plugins/utils'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { Diligence } from '@/plugins/api'

const defaultHeaders = [
  {
    text: 'Học sinh',
    value: 'student',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Lớp',
    value: 'class',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Ngày học',
    value: 'date',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Trạng thái',
    value: 'present',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'CP/KP/Đi muộn',
    value: 'status',
    align: 'left',
    sortable: false,
    show: true
  }
]
export default {
  data() {
    return {
      headers: defaultHeaders,
      tableOptions: {
        page: 1,
        itemsPerPage: 10
      },
      selectedDiligence: null,
      addDiligence: false,
      studentSearchParams: {},
      diligences: [],
      studentCount: 0,
      loading: false,
      dialog: false
    }
  },
  props: {
    filters: Object
  },
  components: {
    CardStudentName
  },
  computed: {
    ...mapGetters('auth', ['ownClassIds']),
    tableFooterOptions() {
      let footerOptions = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': this.tableOptions.itemsPerPage,
        'page-text': utils.paginationText(this.tableOptions, this.studentCount)
      }
      if (this.studentCount > 100) {
        footerOptions['items-per-page-options'] = [5, 10, 15]
      }
      return footerOptions
    }
  },
  methods: {
    ...mapActions('Diligence', ['fetchDiligences']),

    async searchStudentDiligences() {
      this.$loading.active = true
      this.loading = true
      // New filter
      if (this.filters) {
        const filters = this.filters
        if (Array.isArray(this.ownClassIds) && this.ownClassIds.length) filters['class_in'] = this.ownClassIds
        await Diligence.count(filters)
          .then(response => {
            this.studentCount = response
          })
          .catch(error => {
            console.error(error)
            this.$alert.error('Không lấy được số lượng học sinh')
          })
      }
      try {
        const filters = { ...this.filters, ...this.pageSetting() }
        if (Array.isArray(this.ownClassIds) && this.ownClassIds.length) filters['class_in'] = this.ownClassIds
        this.diligences = await Diligence.fetch(filters)
      } catch (error) {
        this.$alert.error('Không lấy được danh sách chuyên cần')
        console.error(error)
      }
      this.loading = false
      this.$loading.active = false
    },
    pageSetting() {
      return {
        _start: (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage,
        _limit: this.tableOptions.itemsPerPage,
        _sort: ['gradeNumber:ASC', 'className:ASC', 'nameToNumber:ASC'].join(',')
      }
    },
    openDialog(item) {
      this.selectedDiligence = item
      this.$nextTick(() => {
        this.dialog = !this.dialog
      })
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.searchStudentDiligences()
        }
      },
      deep: true
    },
    filters: {
      handler(newOptions) {
        if (newOptions) {
          this.tableOptions.page = 1
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
